import { defineComponent as _defineComponent } from 'vue'
import { sanitize } from 'dompurify';
import { faTimes, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
    value: null,
    placeholder: null,
    theme: { default: 'dark' }
  },
  emits: ["input", "submit", "focus", "arrow-down"],
  setup(__props: any, { expose, emit }: { emit: ({
	// for v-model
	(e: 'input', value: string): void;

	(e: 'submit'): void;
	(e: 'focus'): void;
	(e: 'arrow-down'): void;
}), expose: any, slots: any, attrs: any }) {





// Used for keyboard navigation in SearchSuggesterBar.vue
const searchBarInput = ref<HTMLInputElement | null>(null);
expose({ searchBarInput });

function updateSearchQuery(event: Event) {
	emit('input', sanitize((event.target as HTMLInputElement).value.trim()));
}

function submitSearch() {
	emit('submit');
	searchBarInput.value?.blur();
}

return { __sfc: true,emit, searchBarInput, updateSearchQuery, submitSearch, faTimes, faSearch }
}

})